const { fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

function fetchRankingSettings(apiUrl) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v2/ranking/setting',
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching ranking settings',
  });
}

module.exports = {
  fetchRankingSettings,
};
